import jsonp from './lib/jsonp.js';
import md5 from './lib/md5.js';
import { panshi } from '@pms/react-shared';

interface ISsoProps {
  userName: string;
  password: string;
  onError?: () => void;
}

export class Sso {
  version = '1.0.0';
  userName: string;
  password: string;
  props: ISsoProps;

  constructor(props: ISsoProps) {
    this.userName = props.userName;
    this.password = props.password;
    this.props = props;
  }

  public async login() {
    const ticket = await this.getTicket();
    await panshi.user.login(ticket);
  }

  protected async getTicket(): Promise<string> {
    const password = md5(this.password);
    return new Promise((resolve, reject) => {
      jsonp(
        `/sso/sso/login/jsonp.do?userName=${this.userName}&password=${password}`,
        (error, res) => {
          if (error) {
            reject(error);
            this.props.onError?.();
            return;
          }
          resolve(res.ticket);
        },
      );
    });
  }
}
